export default "__VITE_ASSET__C2cCNB$5__"